<div class="main-container" fxLayout="column">
    <mat-toolbar class="topbar relative">
        <img src="./assets/images/logo-top.png" alt="kiksae logo" title="kiksar" class="logo"/>
        <span class="example-spacer"></span>

        <span class="top-rgt-txt" *ngIf="!getUserDetails">Already Registered? &nbsp;&nbsp;<span [routerLink]="['/login']">Login</span></span>
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <mat-card-content>
            <div class="edit-logo txt-center">
              <figure>
                  <img src="{{(getLocalUser && getLocalUser.defaultLogoUrl)? getLocalUser.defaultLogoUrl : './assets/images/Ellipse.png'}}" alt="Company Logo" title="edit company logo" />
              </figure>
              <label for="upload_file"><mat-icon>edit</mat-icon></label>
              <figcaption>{{getUserDetails ? getUserDetails.firstName : ''}}</figcaption>
              <figcaption>{{getUserDetails ? getUserDetails.email : ''}}</figcaption>
              <button mat-raised-button class="txt-center" [routerLink]="['/registration/payment']">
                <span>Manage Account</span>
              </button><br/>
              <button mat-raised-button class="txt-center mt-20" (click)="logout()">
                <span>Logout</span>
              </button>
            </div>
          </mat-card-content>
        </mat-menu>
    </mat-toolbar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>

